<template>
  <div class="card p-3 container-card--preview">
    <div class="card-body p-3 bg-white">
      <div
      v-for="(option) in paymentOptions"
      :key="option.value"
      class="mb-2"
      style="border-radius: 8px;"
      >
        <div class="py-2 px-3 border-container--item">
          <div class="d-flex align-items-center">
            <span class="mr-2">
              <book-icon v-if="option.icon === 'wallet'" size="2x" class="text-dark"></book-icon>
              <credit-card-icon v-else-if="option.icon === 'card'" size="2x" class="text-dark"></credit-card-icon>
              <home-icon v-else-if="option.icon === 'bank'" size="2x" class="text-dark"></home-icon>
            </span>
            <div class="font-weight-bold">{{ option.label }}</div>
          </div>
          <div>
            <circle-icon size="1.5x"></circle-icon>
          </div>
        </div>
      </div>

      <div class="w-full text-right mt-3">
        <button type="button"
          disabled
          class="button-preview__continue"
          :style="{ backgroundColor: buttonsColor }"
        >
          Continuar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { BookIcon, CircleIcon, CreditCardIcon, HomeIcon } from 'vue-feather-icons'
export default {
  name: 'PreviewTabPayment',
  components: {
    CircleIcon,
    CreditCardIcon,
    HomeIcon,
    BookIcon
  },
  props: {
    buttonsColor: {
      type: String,
      default: 'dark'
    }
  },
  data() {
    return {
      paymentOptions: [
        {
          label: 'Billeteras digitales',
          value: 'wallet',
          icon: 'wallet'
        },
        {
          label: 'Tarjetas de débito y crédito',
          value: 'card',
          icon: 'card'
        },
        {
          label: 'Transferencias bancarias',
          value: 'bank',
          icon: 'bank'
        }
      ]
    }
  }
}
</script>
<style scoped>
.container-card--preview {
  background-color: #F2F4F4;
  height: 500px;
  width: 700px;
  max-width: 700px;
}
.border-container--item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #DDE0E4;
  background-color: #F5F9FA;
}
.button-preview__continue {
  padding: 8px 22px;
  border: 8px;
  color: white;
  border-radius: 6px;
}
</style>